import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'yfenBelow';
const args = {};

export class YfenBelow extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
